export default __webpack_public_path__ + "locales/nl/People.json?hash=7e2511df7360503b214e2e59517ab590";